import React from "react";
import * as _ from "lodash";
import { DATA } from "../myanfinviz";
import { DragOutlined } from "@ant-design/icons";
export const COLUMNS = [
  {
    title: "ID",
    dataIndex: "ID",
    key: 0,
    index: 0,
  },
  {
    title: "Type Of Investment",
    dataIndex: "Type Of Investment",
    sorter: (a, b) =>
      a["Name Of Investor"].localeCompare(b["Name Of Investor"]),
    filters: [
      ..._.map(_.groupBy(DATA, "Type Of Investment"), (e) => {
        const text = e[0]["Type Of Investment"];
        const value = text;
        return { text, value };
      }),
    ],
    onFilter: (value, record) => record["Type Of Investment"].includes(value),
    sortDirections: ["descend"],
    key: 1,
    index: 1,
  },
  {
    title: "Name Of Investor",
    dataIndex: "Name Of Investor",
    sorter: (a, b) =>
      a["Name Of Investor"].localeCompare(b["Name Of Investor"]),
    key: 2,
    index: 2,
  },
  {
    title: "Name of Principal Organization",
    dataIndex: "Name of Principal Organization",
    sorter: (a, b) =>
      a["Name of Principal Organization"].localeCompare(
        b["Name of Principal Organization"]
      ),
    key: 3,
    index: 3,
  },
  {
    title: "Place of Incorporation",
    dataIndex: "Place of Incorporation",
    filters: [
      {
        text: "London",
        value: "London",
      },
      {
        text: "New York",
        value: "New York",
      },
    ],
    sorter: (a, b) =>
      a["Place of Incorporation"].localeCompare(b["Place of Incorporation"]),
    key: 4,
    index: 4,
  },
  {
    title: "Company Name In Myanmar",
    dataIndex: "Company Name In Myanmar",
    sorter: (a, b) =>
      a["Company Name In Myanmar"].localeCompare(b["Company Name In Myanmar"]),
    key: 5,
    index: 5,
  },
  {
    title: "Financial Year From",
    dataIndex: "Financial Year From",
    sorter: {
      compare: (a, b) => a["Financial Year From"] - b["Financial Year From"],
    },
    key: 6,
    index: 6,
  },
  {
    title: "Financial Year To",
    dataIndex: "Financial Year To",
    sorter: {
      compare: (a, b) => a["Financial Year To"] - b["Financial Year To"],
    },
    key: 7,
    index: 7,
  },
  {
    title: "Permit Number",
    dataIndex: "Permit Number",
    key: 8,
    index: 8,
  },
  {
    title: "Permit Date",
    dataIndex: "Permit Date",
    key: 9,
    index: 9,
  },
  {
    title: "Meeting Number",
    dataIndex: "Meeting Number",
    key: 10,
    index: 10,
  },
  {
    title: "Meeting Date",
    dataIndex: "Meeting Date",
    key: 11,
    index: 11,
  },
  {
    title: "Sector",
    dataIndex: "Sector",
    sorter: (a, b) => a["Sector"].localeCompare(b["Sector"]),
    key: 12,
    index: 12,
  },
  {
    title: "Type Of Investment Business",
    dataIndex: "Type Of Investment Business",
    defaultSortOrder: "descend",
    sorter: (a, b) =>
      a["Type Of Investment Business"].localeCompare(
        b["Type Of Investment Business"]
      ),
    key: 13,
    index: 13,
  },
  {
    title: "Amount Of Foreign Capital USD (in Millions)",
    dataIndex: "Amount Of Foreign Capital USD (in Millions)",
    defaultSortOrder: "descend",
    key: 14,
    index: 14,
  },
  {
    title: "Total Amount Of Capital (in Millions)",
    dataIndex: "Total Amount Of Capital (in Millions)",
    defaultSortOrder: "descend",
    key: 15,
    index: 15,
  },
  {
    title: "Currency Of Total Amount",
    dataIndex: "Currency Of Total Amount",
    defaultSortOrder: "descend",
    key: 16,
    index: 16,
  },
  {
    title: "Period For Bringing in Foreign Capital (in years)",
    dataIndex: "Period For Bringing in Foreign Capital (in years)",
    defaultSortOrder: "descend",
    key: 17,
    index: 17,
  },
  {
    title: "Validity Of Investment Permit (in Years)",
    dataIndex: "Validity Of Investment Permit (in Years)",
    defaultSortOrder: "descend",
    key: 18,
    index: 18,
  },
  {
    title: "Investing Country",
    dataIndex: "Investing Country",
    defaultSortOrder: "descend",
    key: 19,
    index: 19,
  },
  {
    title: "Form Of Investment",
    dataIndex: "Form Of Investment",
    defaultSortOrder: "descend",
    key: 20,
    index: 20,
  },
  {
    title: "Land Owner",
    dataIndex: "Land Owner",
    defaultSortOrder: "descend",
    key: 21,
    index: 21,
  },
  {
    title: "Land Area (units not specified in file)",
    dataIndex: "Land Area (units not specified in file)",
    defaultSortOrder: "descend",
    key: 22,
    index: 22,
  },
  {
    title: "Lease Term",
    dataIndex: "ToLease Term",
    defaultSortOrder: "descend",
    key: 23,
    index: 23,
  },
  {
    title: "Annual Lease Fee",
    dataIndex: "Annual Lease Fee",
    defaultSortOrder: "descend",
    key: 24,
    index: 24,
  },
  {
    title: "Land Use Premium",
    dataIndex: "Land Use Premium",
    defaultSortOrder: "descend",
    key: 25,
    index: 25,
  },
  {
    title: "Number Of Local Employees",
    dataIndex: "Number Of Local Employees",
    defaultSortOrder: "descend",
    sorter: {
      compare: (a, b) =>
        a["Number Of Local Employees"] - b["Number Of Local Employees"],
      multiple: 2,
    },
    key: 26,
    index: 26,
  },
  {
    title: "Number Of Foreign Employees",
    dataIndex: "Number Of Foreign Employees",
    sorter: {
      compare: (a, b) =>
        a["Number Of Foreign Employees"] - b["Number Of Foreign Employees"],
      multiple: 1,
    },
    defaultSortOrder: "descend",
    key: 27,
    index: 27,
  },
  {
    title: "Status",
    dataIndex: "Status",
    defaultSortOrder: "descend",
    key: 28,
    index: 28,
  },
  {
    title: "Investor Address",
    dataIndex: "Investor Address",
    defaultSortOrder: "descend",
    key: 29,
    index: 29,
  },
  {
    title: "Organization Address",
    dataIndex: "Organization Address",
    defaultSortOrder: "descend",
    key: 30,
    index: 30,
  },
  {
    title: "Investment Permitted Address",
    dataIndex: "Investment Permitted Address",
    defaultSortOrder: "descend",
    key: 31,
    index: 31,
  },
];

// export const COLUMN_MAPS = {
//   "ID": {
//     label: "ID",
//     value: "id"
//   },"Type Of Investment": {
//     label: "Type Of Investment",
//     value: "type_of_investment"
//   },
//   "Type Of Investment",
//   "Name Of Investor",
//   "Company Name In Myanmar",
//   "Type Of Investment Business",
//   "Sector",
//   // "Number Of Local Employees",
//   // "Number Of Foreign Employees",
//   // "ID",
//   // "Type Of Investment",
//   // "Name Of Investor",
//   // "Name of Principal Organization",
//   // "Place of Incorporation",
//   // "Company Name In Myanmar",
//   // "Financial Year From",
//   // "Financial Year To",
//   // "Permit Number",
//   // "Permit Date",
//   // "Meeting Number",
//   // "Meeting Date",
//   // "Sector",
//   // "Type Of Investment Business",
//   // "Amount Of Foreign Capital USD (in Millions)",
//   // "Total Amount Of Capital (in Millions)",
//   // "Currency Of Total Amount",
//   // "Period For Bringing in Foreign Capital (in years)",
//   // "Validity Of Investment Permit (in Years)",
//   "Investing Country",
//   // "Form Of Investment",
//   // "Land Owner",
//   // "Land Area (units not specified in file)",
//   // "Lease Term",
//   // "Annual Lease Fee",
//   // "Land Use Premium",
//   // "Number Of Local Employees",
//   // "Number Of Foreign Employees",
//   // "Status",
//   // "Investor Address",
//   // "Organization Address",
//   // "Investment Permitted Address",
// }
